import { IStoreEntityStateSlice, createEntitySlice } from '@aston/foundation/store';
import { IFactorConfiguration } from '@aston/foundation/models';

import { IUser, IUserSession } from '../../authentication-module/models/user.model';
import { ITenantIdentity } from '../../shared-module/models/tenant.model';
import { AppConfiguration } from '../../app.configuration';

export interface IAppState {
	isLoading: boolean;
	isFinished: boolean;
	bootstrapError: Error;
	validatorsLoaded: boolean;
	config: AppConfiguration;
	factorConfig: IStoreEntityStateSlice<IFactorConfiguration>;
	tenant: IStoreEntityStateSlice<ITenantIdentity>;
	user: IUser;
	scripts: Record<string, boolean>;
	userSession: IUserSession;
}

export const initialState: IAppState = {
	isLoading: true,
	isFinished: false,
	bootstrapError: null,
	validatorsLoaded: false,
	config: null,
	factorConfig: createEntitySlice(),
	tenant: createEntitySlice(),
	user: null,
	scripts: {},
	userSession: {},
};
